module.exports = __webpack_public_path__ + "files/cc62032273590baeb92688b6253c0b40.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bold-webfont.woff
 ** module id = 886
 ** module chunks = 0
 **/